import { render, staticRenderFns } from "./BonusModal.vue?vue&type=template&id=9ab9845c&scoped=true&"
import script from "./BonusModal.vue?vue&type=script&lang=js&"
export * from "./BonusModal.vue?vue&type=script&lang=js&"
import style0 from "./BonusModal.vue?vue&type=style&index=0&id=9ab9845c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab9845c",
  null
  
)

export default component.exports